import React from "react";
import { Flex, useMultiStyleConfig } from "@chakra-ui/react";
import ArticleListItem from "@/components/ArticleListItem/ArticleListItem";

export interface Article {
	coverPhotoUrl: string;
	date: string;
	title: string;
	description: string;
	link: string;
}

export interface ArticleListProps {
	articles: Article[];
	title: string;
	tooltip: string;
	bgColor?: string;
	useExternalSource?: boolean;
}

function ArticleList({ articles }: ArticleListProps) {
	const styleParts = useMultiStyleConfig("ArticleList");

	return (
		<Flex className="articleList" sx={styleParts.root}>
			<Flex className="articleListContentContainer" sx={styleParts.contentContainer}>
				<Flex className="articleListItemContainer" sx={styleParts.articleListItemContainer}>
					{articles.length === 0 && <>loading</>}
					{articles.length > 0 &&
						articles.map(({ coverPhotoUrl, date, title, description, link }, articleIndex) => {
							return (
								<ArticleListItem
									className="articleListItem"
									key={articleIndex}
									coverPhotoUrl={coverPhotoUrl}
									date={date}
									title={title}
									description={description}
									link={link}
								/>
							);
						})}
				</Flex>
			</Flex>
		</Flex>
	);
}

export default ArticleList;
